import graphqlClient from '../../api/axios_interceptor';

import {
    FETCH_OPTIONS
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';


import {
    getOptionsQuery
} from "../../api/graphql/queries/options";




const fetchOptionsMiddleware = async (action) => {
    try{
        await graphqlClient({
            data: {
                query: getOptionsQuery()
            }
        }).then( (queryResult) => {
            action = {
                ...action,
                payload: {
                    ...action.payload,
                    paymentTypes: queryResult.data.data.paymentTypes,
                    invoiceItems: queryResult.data.data.transactionCategories,
                    paymentMethods: queryResult.data.data.paymentMethods,
                    expenseCategories: queryResult.data.data.expenseCategories,
                    allowedCurrencies: queryResult.data.data.allowedCurrencies,
                    availableTimezones: queryResult.data.data.availableTimezones,
                    otherRecurringBillItems: queryResult.data.data.otherRecurringBillItems,
                    allReportColumns: queryResult.data.data.allReportColumns,
                    reportSettings: queryResult.data.data.reportSettings,
                    chartMomOptions: queryResult.data.data.chartMomOptions,
                    chartGroupingOptions: queryResult.data.data.chartGroupingOptions,
                    maintenanceCategories: queryResult.data.data.maintenanceCategories,
                    maintenanceStatuses: queryResult.data.data.maintenanceStatuses,
                    allowedSmsBankTypes: queryResult.data.data.allowedSmsBankTypes,
                    leaseExpiryReminderDays: queryResult.data.data.leaseExpiryReminderDays,
                    allPermissions: JSON.parse(queryResult.data.data.allPerms),
                    allMessageTypes: queryResult.data.data.allMessageTypes,
                    userPermissions: queryResult.data.data.userPerms,
                    allAccountTypes: queryResult.data.data.allAccountTypes,
                    userAccountType: queryResult.data.data.userAccountType
                }
            };
        })
    }catch(error){
        console.log(error);
        action = updateActionErrors(action);
    }
    return action;
}

export const optionsMiddleware = storeAPI => next => async action => {

    switch(action.type){
        case FETCH_OPTIONS:
            action = await fetchOptionsMiddleware(action);
            break;
    }
    return next(action);
}